import { render, staticRenderFns } from "./extraHeadersComponent.vue?vue&type=template&id=0c921ff1&scoped=true"
import script from "./extraHeadersComponent.vue?vue&type=script&lang=js"
export * from "./extraHeadersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c921ff1",
  null
  
)

export default component.exports